<mat-card
  [@cardAnimator]="animationState"
  (@cardAnimator.done)="resetAnimationState()"
  class="contrast product-card"
  [class.banner-info]="selected"
  [class.banner-warning]="item?.disabled"
  [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
    <mat-card-content class="h-100" fxLayout="column" fxLayoutAlign="space-between stretch" fxLayoutGap="5px">
        <div class="product-thumbnail-translate-container" [ngClass]="{ 'expanded': isImageExpanded, 'shrinking': isImageShrinking }" [ngStyle]="{'transform': 'translate(' + expandedCardTranslationX + 'px, 0px)'}" >
            <div class="product-thumbnail" [ngClass]="{ 'expanded': isImageExpanded, 'shrinking': isImageShrinking }" (mouseenter)="onMouseEnterImage()" (mouseleave)="onMouseLeaveImage()">
                
                <ng-template #imgTemplate>
                    <img *ngIf="item?.previewArtifactId && !isImageExpanded" class="image" src="/assets/images/image-loading-icon.svg" lazyLoad="{{situView}}/home/getimage?artifactid={{item.previewArtifactId}}&filename=thumbnail.webp" errorImage="/assets/images/no-image-icon.svg">
                    <img *ngIf="!item?.previewArtifactId" class="no-image" src="/assets/images/{{noPreviewImageIcon}}">

                    <span *ngIf="item?.previewArtifactId && isImageExpanded" class="expanded-image-container" (mousemove)="onMouseMoveImage($event)">
                        <img class="image" [ngStyle]="{'transform': 'translate(' + imageX + 'px, ' + imageY + 'px)'}" 
                            src="{{situView}}/home/getimage?artifactid={{item.previewArtifactId}}&filename={{imageName}}.webp">
                    </span>
                </ng-template>
                <a *ngIf="(editProductOnClick && userCanEditProduct()) else imgTemplate" class="image-container" routerLink="/products/{{ item.id }}" (click)="$event.stopPropagation();" routerLinkActive="active">
                    <ng-container *ngTemplateOutlet="imgTemplate"></ng-container>
                </a>

                <a *ngIf="!isCatalog && userCanEditProduct()" routerLink="/products/{{ item.id }}" (click)="$event.stopPropagation();" routerLinkActive="active">
                    <mat-icon class="edit-button link" color="accent" matTooltip="Edit Product">edit</mat-icon>
                </a>
                <mat-icon class="edit-button link" *ngIf="isCatalog && item?.previewArtifactId && userCanEditProduct()" (click)="onView3dPreview(item); $event.stopPropagation();" color="accent" matTooltip="Open Preview">view_in_ar</mat-icon>
                <mat-icon class="share-button link" *ngIf="isCatalog && !item?.previewArtifactId && isSituUser && selectedCompanyId === item?.companyId" (click)="getPreview(item?.callerReferenceKey); $event.stopPropagation();" color="accent" matTooltip="Generate Preview">preview</mat-icon>
                <mat-icon class="share-button link" *ngIf="isCatalog && item?.previewArtifactId" (click)="share(item?.previewArtifactId); $event.stopPropagation();" color="accent" matTooltip="Share situLINK">share</mat-icon>
                
                <mat-icon class="download-button link" *ngIf="!showDownloadOptions && isCatalog && item?.previewArtifactId && (isSituUser || (isAdmin && selectedCompanyId == item?.companyId))" (click)="showDownloadOptions = true; $event.stopPropagation();" color="accent" matTooltip="Show download options">download</mat-icon>
                <div class="download-options" (click)="$event.stopPropagation()" *ngIf="showDownloadOptions && isCatalog && item?.previewArtifactId && (isSituUser || (isAdmin && selectedCompanyId == item?.companyId))" fxLayout="row" fxLayoutAlign="space-between center">
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="3px">
                        <strong class="m-l-5">GLB</strong>
                        <mat-icon (click)="downloadFile('product.glb')" color="accent" class="link" matTooltip="Download GLB for Android AR">android</mat-icon>
                        <strong>USDZ</strong>
                        <svg class="apple-icon"
                            (click)="downloadFile('product.usdz')"
                            matTooltip="Download USDZ for iOS AR"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 384 512">
                            <!-- Font Awesome Free 6.6.0 by @fontawesome -->
                            <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"/>
                        </svg>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="end end">
                        <mat-icon (click)="showDownloadOptions = false; $event.stopPropagation();" color="primary" class="link small-icon" matTooltip="Hide download options">clear</mat-icon>
                    </div>
                </div>

                <div class="product-thumbnail-lower" (click)="$event.stopPropagation()">
                    <img class="product-company-logo card-link"
                    *ngIf="companyLogo"
                    [lazyLoad]="companyLogo"
                    matTooltip="Show {{ companyName }} products"
                    (click)="selectCompanyByProductCompanyId(item?.companyId)">

                    <div class="product-company-name card-link"
                    *ngIf="!companyLogo && companyName"
                    matTooltip="Show {{ companyName }} products"
                    (click)="selectCompanyByProductCompanyId(item?.companyId)">
                        <div>
                            {{ companyName }}
                        </div>
                    </div>

                    <a class="theme-usage-count card-link" *ngIf="item?.themeUsageCount"
                    routerLink="/products/{{ item.id }}"
                    [queryParams]="{ tab: 1 }"
                    target="_blank"
                    [matTooltip]="themeUsageTooltip"
                    matTooltipClass="theme-usage-tooltip"
                    (click)="$event.stopPropagation()">
                        {{ item.themeUsageCount }}
                    </a>

                    <div class="product-type-indicator card-link"
                    [style.background-color]="productTypeColor"
                    matTooltip="Filter by {{ productTypeName }}"
                    (click)="selectProductTypeByProduct(item?.productTypeId)">
                    </div>
                </div>
            </div>
        </div>
        <div class="product-name" fxLayout="column" fxLayoutAlign="center center">
            <span *ngIf="!isCatalog" class="small" [innerHtml]="item?.name | encodeHtml | highlight: searchTerm" matTooltip="Select {{ item?.name }}"></span>
            <span *ngIf="isCatalog" (click)="copyManufacturerProductDetails(item); $event.stopPropagation();" class="small" [innerHtml]="item?.name | encodeHtml | highlight: searchTerm" matTooltip="Manufacturer: {{ companyName }} / SKU: {{ getKeySku(item) }} / Display SKU: {{ item?.sku }}"></span>
            <!-- {{ item | json }} -->
        </div>
    </mat-card-content>
</mat-card>
